export default "__VITE_ASSET__Cns3EISq__"